import { makeStyles } from '@material-ui/styles';

import { ArrowLeftSLine, CloseFill, IconButton } from '@bizzabo/design-system';

interface SchedulingOverlayWrapperProps {
    isBackBtnShow?: boolean;
    onClickBack?: () => void;
    onClose: () => void;
}

const SchedulingOverlayWrapper: React.FC<SchedulingOverlayWrapperProps> = ({
    children,
    isBackBtnShow,
    onClickBack = () => {},
    onClose,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.row}>
                {isBackBtnShow && (
                    <div className={classes.backBtnWrapper}>
                        <IconButton
                            className={classes.backBtn}
                            icon={ArrowLeftSLine}
                            onClick={onClickBack}
                            variant="fillPrimary"
                        />
                    </div>
                )}
                <IconButton
                    className={classes.closeButton}
                    onClick={onClose}
                    icon={CloseFill}
                    variant="fillPrimary"
                />
            </div>
            {children}
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        root: {
            padding: '24px 32px',
            width: '100%',
            height: '100%',
            backgroundColor: '#EBEBEB',
            display: 'flex',
            flexDirection: 'column',
        },
        backBtnWrapper: {
            flex: 1,
        },
        backBtn: {
            width: 22,
            height: 22,
            color: '#767676',
            backgroundColor: 'transparent',
        },
        closeButton: {
            width: 22,
            height: 22,
            color: '#767676',
            background: 'none',
        },
        row: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 16,
        },
    }),
    { classNamePrefix: 'meetings-scheduling-overlay-wrapper' }
);

export default SchedulingOverlayWrapper;
